// Server totals are independent of the bounded preview lists. Never replace
// them with list.length, invent zero, or guess how many old demo rows existed.
export const dashboardCounts=(raw,legacyPresent)=>Object.fromEntries(
  ["urgent_emails","reply_needed","active_tasks","reminders"].map(key=>{
    const count=raw.counts?.[key];
    const list=raw[key];
    const valid=!legacyPresent&&Number.isSafeInteger(count)&&count>=0&&(!Array.isArray(list)||count>=list.length);
    return [key,valid?count:null];
  })
);
